//store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		// 定义一个name，以供全局使用
		name: '',
		// 定义一个list，以供全局使用
		list: [],
		tableTotal: 0,
		pageNum: 1
	},
	mutations: {
		saveList(state, list) {
			state.list = list
		},
		saveInput(state, name) {
			state.name = name
		},
		saveTableTotal(state, total) {
			state.tableTotal = total
		},
		saveTablePageNum(state, pageNum) {
			state.pageNum = pageNum
		},
	},
	actions: {
		saveAsync(context, list) {
			setTimeout(() => {
				// 在 actions 中，不能直接修改 state 中的数据；
				// 必须通过 context.commit() 触发某个 mutation 才行
				context.commit('saveList', list)
			}, 1000)
		},
		saveAsyncInput(context, name) {
			setTimeout(() => {
				// 在 actions 中，不能直接修改 state 中的数据；
				// 必须通过 context.commit() 触发某个 mutation 才行
				context.commit('saveInput', name)
			}, 1000)
		},
		saveAsyncTableTotal(context, total) {
			setTimeout(() => {
				// 在 actions 中，不能直接修改 state 中的数据；
				// 必须通过 context.commit() 触发某个 mutation 才行
				context.commit('saveTableTotal', total)
			}, 1000)
		},
		saveAsyncTablePageNum(context, pageNum) {
			setTimeout(() => {
				// 在 actions 中，不能直接修改 state 中的数据；
				// 必须通过 context.commit() 触发某个 mutation 才行
				context.commit('saveTablePageNum', pageNum)
			}, 1000)
		}
	}
});

export default store;